import React from "react";
import Select from "react-select";

export default function FormCustom(props) {
  const {
    title,
    formDataArr,
    handleSubmit,
    handleCancelButton,
    setData,
    editFormValue,
  } = props;

  // const inputElementRef = useRef([]);

  // ...

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <form onSubmit={handleSubmit}>
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-blueGray-700 text-xl font-bold">
                Form {title ? title : "Data"}
              </h6>
              <div>
                {handleCancelButton && (
                  <button
                    className="mr-3 mb-3 bg-gray-400 text-gray-800 active:bg-red-300 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleCancelButton}
                  >
                    Cancel
                  </button>
                )}

                <button
                  className="mr-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="submit"
                >
                  Save
                </button>
                {/* <button
                      className="mr-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleClearButton}
                    >
                      Clear
                    </button> */}
              </div>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div className="flex flex-wrap">
              <h6 className="w-full text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                Form Data
              </h6>
              {formDataArr.map((data) => {
                return (
                  <div key={data.id} className="w-full lg:w-11/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor={data.id}
                        key={data.id}
                      >
                        {data.label}
                      </label>
                      {data.fields.map((field, i) => {
                        switch (field.type) {
                          case "option":
                            return (
                              <Select
                                key={data.id}
                                className="border-0 px-1 py-1 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                onChange={(e) => setData(data.id, e.value)}
                                options={field.options}
                                defaultValue={
                                  editFormValue && {
                                    label: editFormValue[data.id],
                                    value: editFormValue[data.id],
                                  }
                                }
                                isSearchable={true}
                              />
                            );
                          case "file":
                            return (
                              <div key={data.id}>
                                <input
                                  type="file"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder={field.placeholder}
                                  key={data.id}
                                  defaultValue={
                                    editFormValue ? editFormValue[data.id] : ""
                                  }
                                  onChange={(e) =>
                                    setData(data.id, e.target.files[0])
                                  }
                                />
                              </div>
                            );
                          case "file_multiple":
                            return (
                              <div key={data.id}>
                                <input
                                  type="file"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder={field.placeholder}
                                  key={data.id}
                                  defaultValue={
                                    editFormValue ? editFormValue[data.id] : ""
                                  }
                                  onChange={(e) =>
                                    setData(data.id, e.target.files)
                                  }
                                  multiple={true}
                                />
                              </div>
                            );
                          case "date":
                            return (
                              <div key={data.id}>
                                <input
                                  type="date"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder={field.placeholder}
                                  key={data.id}
                                  defaultValue={
                                    editFormValue
                                      ? editFormValue[data.id]
                                      : field.defaultDate
                                      ? field.defaultDateValue
                                      : ""
                                  }
                                  onChange={(e) =>
                                    setData(data.id, e.target.value)
                                  }
                                  // ref={el => inputElementRef.current[i] = el}
                                />
                              </div>
                            );
                          case "email":
                            return (
                              <div key={data.id}>
                                <input
                                  type="email"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder={field.placeholder}
                                  key={data.id}
                                  defaultValue={
                                    editFormValue ? editFormValue[data.id] : ""
                                  }
                                  onChange={(e) =>
                                    setData(data.id, e.target.value)
                                  }
                                  // ref={el => inputElementRef.current[i] = el}
                                />
                              </div>
                            );
                          case "password":
                            return (
                              <div key={data.id}>
                                <input
                                  type="password"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder={field.placeholder}
                                  key={data.id}
                                  defaultValue={
                                    editFormValue ? editFormValue[data.id] : ""
                                  }
                                  onChange={(e) =>
                                    setData(data.id, e.target.value)
                                  }
                                  // ref={el => inputElementRef.current[i] = el}
                                />
                              </div>
                            );
                          case "readonly":
                            return (
                              <div key={data.id}>
                                <input
                                  type="text"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  key={data.id}
                                  defaultValue={field.defaultValue}
                                  onChange={(e) =>
                                    setData(data.id, e.target.value)
                                  }
                                  readOnly
                                />
                              </div>
                            );
                          case "input":
                          default:
                            return (
                              <div key={data.id}>
                                <input
                                  type="text"
                                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder={field.placeholder}
                                  key={data.id}
                                  defaultValue={
                                    editFormValue ? editFormValue[data.id] : ""
                                  }
                                  onChange={(e) =>
                                    setData(data.id, e.target.value)
                                  }
                                  // ref={el => inputElementRef.current[i] = el}
                                />
                              </div>
                            );
                        }
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
